/* eslint-disable max-len */
import EaSuperFeature from '@propertypal/shared/src/resources/icons/products/ea-superfeatured-homepage-icon.svg';
import AgentSuperFeatureMockup from '@propertypal/shared/src/resources/images/superfeatured-homepage/ea-superfeatured-homepage-mockup.png';
import platform from '@propertypal/shared/src/utils/platform';
import ProductsPageHeader from '@propertypal/web-ui/src/headers/products/ProductsPageHeader';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import ProductScreenTabs, { ProductScreenTab } from '@propertypal/web-ui/src/products/ProductScreenTabs';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: `Estate Agent Superfeatured Homepage - ${platform.title}`,
  description: 'Highlight exceptional properties for maximum visibility.',
  url: `/products/estate-agents/superfeatured-homepage`,
};

const tabs: ProductScreenTab[] = [
  {
    title: 'Additional exposure',
    text: `Your property and brand on the homepage of Northern Ireland's largest property website.`,
    maxW: 355,
  },
  {
    title: 'High impact',
    text: `Largest ad unit on ${platform.title} enabling you to create high impact and receive more clicks through to your property details page.`,
    maxW: 335,
  },
  {
    title: 'Get more enquiries',
    text: `Your properties promoted to active buyers before they even begin their search.`,
    maxW: 320,
  },
];

const AgentsSuperfeaturedHomepage = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsPageHeader
        title="Superfeatured Homepage"
        text="Highlight exceptional properties for maximum visibility"
        headingProps={{ mb: 10 }}
        subHeadingProps={{ mb: 0 }}
        icon={<EaSuperFeature />}
      />
      <ProductScreenTabs
        tabs={tabs}
        badge={{
          color: 'primary',
          title: 'FREE',
          text: 'EXPOSURE',
        }}
        aspectRatio="547 / 457"
        reverse
        smallPrint={`There is no charge for this additional exposure however properties are selected at ${platform.title}'s discretion.`}
        pb={30}
        button={{
          onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
          text: 'Contact us',
          containerStyle: { maxWidth: '280px' },
        }}
        maxW={1120}
        breakpoint={1120}
        staticTabs
        mockup={AgentSuperFeatureMockup}
        tabsMt={-15}
        buttonXPadding={15}
        buttonMt={0}
      />
      <ProductsContact reason="Estate Agent Superfeatured Homepage" />
    </>
  );
};

export default AgentsSuperfeaturedHomepage;
